<button mat-button data-action="select-time" (click)="setTime()" *ngIf="value">
  <mat-icon>{{ icon ? icon : 'history' }}</mat-icon>
  <span [ngSwitch]="value!.period">
    <span i18n *ngSwitchCase="periodSelection.OneHour">Last Hour</span>
    <span i18n *ngSwitchCase="periodSelection.SixHours">Last Six Hours</span>
    <span i18n *ngSwitchCase="periodSelection.TwelveHours"
      >Last Twelve Hours</span
    >
    <span i18n *ngSwitchCase="periodSelection.OneDay">Last Day</span>
    <span i18n *ngSwitchCase="periodSelection.SevenDays">Last Week</span>
    <span i18n *ngSwitchCase="periodSelection.ThirtyDays">Last Month</span>
    <span i18n *ngSwitchCase="periodSelection.OneYear">Last Year</span>
    <span i18n *ngSwitchCase="periodSelection.ThreeYears"
      >Last Three Years</span
    >
    <span i18n *ngSwitchCase="periodSelection.FiveYears">Last Five Years</span>
    <span i18n *ngSwitchCase="periodSelection.Custom">
      {{ value.fromDate | date: 'short' }} -
      {{ value.toDate | date: 'short' }}
    </span>
    <p i18n *ngSwitchDefault>Not Selected</p>
  </span>
</button>
